import type { ProductReviewsSummary } from '../../types';
import type { ProductReviewsTranslations } from '../ProductReviewsElement.types';
import { StarRating } from './StarRating';

interface RatingSummaryProps {
  summary: ProductReviewsSummary;
  translations?: ProductReviewsTranslations;
}

export function RatingSummary({ summary, translations }: RatingSummaryProps) {
  const reviewText =
    summary.total_reviews_count === 1
      ? (translations?.['product_reviews.review'] ?? 'review')
      : (translations?.['product_reviews.reviews'] ?? 'reviews');
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <StarRating score={1} size={24} maxStars={1} variant="summary" />
      <span
        style={{
          fontWeight: 'var(--product-reviews-summary-font-weight, 510)',
          color: 'var(--product-reviews-summary-text-color, var(--text))',
          fontSize: 'var(--product-reviews-summary-font-size, 16px)',
          fontFamily: 'var(--product-reviews-summary-font-family, inherit)',
          lineHeight: '24px',
        }}
      >
        {summary.average_score.toFixed(1)}
      </span>
      <span
        style={{
          color: 'var(--product-reviews-summary-count-color, var(--text-light))',
          fontSize: 'var(--product-reviews-summary-font-size, 16px)',
          fontFamily: 'var(--product-reviews-summary-font-family, inherit)',
          lineHeight: '24px',
        }}
      >
        ({summary.total_reviews_count.toLocaleString()} {reviewText})
      </span>
    </div>
  );
}
